import React, { FC } from "react";

interface ModalSubtitleProps {}

const ModalSubtitle: FC<ModalSubtitleProps> = ({ children }) => {
  return <div className="body1 text-dark-light-grey">{children}</div>;
};

export default ModalSubtitle;
